<div class="order-list-wrapper">
    <section class="order-list-panel-header">
        <h4>{{config?.listPanel?.title || 'Orders'}}</h4>
        <ng-container *ngIf="canUserAdd()">
            <gen-button id="addOrderBtn" class="add-button" [ngClass]="" (click)="createOrder()" [type]="'primary'"
                [text]="addBtnLabel" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true"
                [iconClass]="'icon__Plus'" [disabled]="disableAddButton">
            </gen-button>
        </ng-container>
    </section>
    <section class="order-list-body">
        <ng-container *ngIf="loading;">
            <gen-overlay-loader [showOverlay]="false"></gen-overlay-loader>
        </ng-container>

        <section class="list-titles" *ngIf="config?.listPanel?.listItems?.length>0"
            [ngClass]="{'titles-read-only-mode': disabled, 'titles-edit-mode': !disabled}">
            <ng-container *ngFor="let field of config?.listPanel?.listItems" [class.requiredField]="field?.required">
                <span *ngIf="!field.header">{{field.label | translate}}</span>
            </ng-container>

        </section>

        <div class="order-list-scroll-container">
            <dls-list-view class="pt-bordered">
                <dls-list-item *ngFor="let item of orders;index as i; trackBy:trackByFn" class="pt-separator"
                    [selected]="item?.id == selectedOrder?.id" (click)="changeOrder(item)">
                    <div class="order-list-rows">
                        <div class="order-list-items pt-multiline" *ngFor="let key of config?.listPanel?.listItems">
                            <label *ngIf="key.header"> {{ getValue(item, key?.path,key?.defaultValue) }} </label>
                            <section *ngIf="!key.header" class="pt-list-subitem pt-tertiary"> {{ getValue(item,
                                key?.path,key?.defaultValue) }} </section>
                        </div>
                    </div>
                    <section class="last-column">
                        <gen-button id="deleteOrderBtn" class="delete-button" [ngClass]=""
                            [disabled]="!canUserDelete(item)" (click)="deleteOrder(item)" [type]="'quite'" [text]="''"
                            genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [iconClass]="'icon__trash'">
                        </gen-button>
                    </section>
                </dls-list-item>
            </dls-list-view>
        </div>
        <div class="empty-message-display" *ngIf="orders?.length === 0 || !orders">{{'No Data Available' | translate}}
        </div>

    </section>
</div>